import { render, staticRenderFns } from "./LegalKitkit.vue?vue&type=template&id=48b4fb18&scoped=true&"
import script from "./LegalKitkit.vue?vue&type=script&lang=js&"
export * from "./LegalKitkit.vue?vue&type=script&lang=js&"
import style0 from "./LegalKitkit.vue?vue&type=style&index=0&id=48b4fb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b4fb18",
  null
  
)

export default component.exports